import React from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import mobileLogo from "../assets/images/letter-logo-mobile.png";
import stylesGlobal from "../../Navbar/styles/stylesGlobal";
import stylesMobile from "../../Navbar/styles/stylesMobile";
import useNavbarLogic from "../../Navbar/hooks/useNavbarLogic"; // ✅ Importa o hook

function NavbarMobile() {
  const {
    activeSection,
    isHovered,
    setIsHovered,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    menuRef,
    buttonRef,
    scrollToSection,
    scrollToContact,
  } = useNavbarLogic();

  return (
    <nav style={{ ...stylesGlobal.navbar, ...stylesMobile.navbarMobile }}>
      <button
        ref={buttonRef}
        style={stylesMobile.hamburger}
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {/* Ícones sobrepostos com transição */}
        <div style={{ position: "relative", width: "30px", height: "30px" }}>
          <AiOutlineMenu
            size={30}
            style={{
              ...stylesMobile.icon,
              opacity: isMobileMenuOpen ? 0 : 1,
              transform: isMobileMenuOpen ? "scale(0.8)" : "scale(1)",
            }}
          />
          <AiOutlineClose
            size={30}
            style={{
              ...stylesMobile.icon,
              opacity: isMobileMenuOpen ? 1 : 0,
              transform: isMobileMenuOpen ? "scale(1)" : "scale(0.8)",
            }}
          />
        </div>
      </button>

      <div style={stylesGlobal.logoContainer}>
        <img src={mobileLogo} alt="Logo" style={stylesMobile.logoImageMobile} />
      </div>

      <button
        style={{
          ...stylesMobile.buttonMobile,
          ...(isHovered ? stylesGlobal.buttonHover : {}),
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={scrollToContact} // ✅ Agora usa a função do hook
      >
        Contato
      </button>

      {isMobileMenuOpen && (
        <div ref={menuRef} style={stylesMobile.mobileMenu}>
          <ul style={stylesMobile.mobileMenuList}>
            {["hero", "solutions", "portfolio"].map((section, index) => (
              <React.Fragment key={section}>
                <li
                  style={{
                    ...stylesMobile.mobileMenuItem,
                    ...(activeSection === section ? stylesGlobal.linkActive : {}),
                  }}
                  onClick={() => scrollToSection(section)}
                >
                  {section === "hero"
                    ? "Início"
                    : section === "solutions"
                    ? "Soluções"
                    : "Portfólio"}
                </li>
                {index < 2 && <li style={stylesMobile.divider} />}
              </React.Fragment>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}

export default NavbarMobile;
